const ENOriginOccurrences = {
	"Alterar origem de ocorrência" : "Change occurrence origin",
	"Deseja realmente excluir a origem de ocorrência" : "Do you really want to delete the occurrence origin",
	"Erro ao adicionar origem de ocorrência" : "Error adding occurrence origin",
	"Erro ao alterar origem de ocorrência" : "Error on changing occurrence origin",
	"Erro ao excluir origem de ocorrência" : "Error on deleting occurrence origin",
	"Exclusão de origem de ocorrência" : "Delete occurrence origin",
	"Inserção de origem de ocorrência" : "Insert occurrence origin",
	"Nova origem de ocorrências" : "New occurrence origin",
	"Origens de Ocorrências" : "Origins of Occurrences",
	"Origens de ocorrências" : "Origins of occurrences",
	"Origem de ocorrência adicionada com sucesso" : "Occurrence origin successfully added",
	"Origem de ocorrência alterada com sucesso" : "Occurrence origin successfully changed",
	"Origem de ocorrência excluída com sucesso" : "Occurrence origin successfully deleted",
	"Requisitos de ocorrências": "Occurrence requirements"
};

export default ENOriginOccurrences;

